import { api } from '@services/api'

export const fetcherDataApi = async (url: string): Promise<any> => {
  return api.get(url).then(r => r.data)
}
